<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="pz11-1">
					Contents </p>
<p class="ctt" id="pz11-2">
<b><a href="#/chapter01#pz17-1" id="ch1">Chapter 1</a></b></p>
<p class="ctt1" id="pz11-3"><a href="#/chapter01">
					Out of Nothing, Something</a></p>
<p class="ctt" id="pz11-4">
<b><a href="#/chapter02#pz20-2" id="ch2">Chapter 2</a></b></p>
<p class="ctt1" id="pz11-5"><a href="#/chapter02">
					So Many Questions</a></p>
<p class="ctt" id="pz11-6">
<b><a href="#/chapter03#pz24-2" id="ch3">Chapter 3</a></b></p>
<p class="ctt1" id="pz11-7"><a href="#/chapter03">
					Thomas Jefferson: The Episcopalian Unitarian</a></p>
<p class="ctt" id="pz11-11">
<b><span href="#/chapter04#pz30-2" id="ch4" title="Link target outside of Sample">Chapter 4</span></b></p>
<p class="ctt1" id="pz11-12"><span href="#/chapter04" title="Link target outside of Sample">
					The Power of One:</span></p>
<p class="ctt2"><span href="#/chapter04" title="Link target outside of Sample">One Vote Matters, and One Percent Is Significant</span></p>
<p class="ctt" id="pz11-14"><b><span href="#/chapter05#pz35-1" id="ch5" title="Link target outside of Sample">Chapter 5</span></b></p>
<p class="ctt1" id="pz11-15"><span href="#/chapter05" title="Link target outside of Sample">
					Four of John Steinbeck’s Novels:</span></p>
<p class="ctt2"><span href="#/chapter05" title="Link target outside of Sample">A Selective, Annotative Bibliography</span></p>
<p class="ctt" id="pz11-17"><b><span href="#/chapter06#pz51-2" id="ch6" title="Link target outside of Sample">Chapter 6</span></b></p>
<p class="ctt1" id="pz11-18"><span href="#/chapter06" title="Link target outside of Sample">
					Wisdom Comes Quietly</span></p>
<p class="ctt" id="pz11-22"><b><span href="#/chapter07#pz58-2" id="ch7" title="Link target outside of Sample">Chapter 7</span></b></p>
<p class="ctt1" id="pz11-23"><span href="#/chapter07" title="Link target outside of Sample">
					Pensees: Small Thoughts and Reflections</span></p>
<p class="ctt" id="pz11-25"><b><span href="#/chapter08#pz66-1" id="ch8" title="Link target outside of Sample">Chapter 8</span></b></p>
<p class="ctt1" id="pz11-26"><span href="#/chapter08" title="Link target outside of Sample">
					What Is Holy?</span></p>
<p class="ctt" id="pz12-1"><b><span href="#/chapter09#pz70-2" id="ch9" title="Link target outside of Sample">Chapter 9</span></b></p>
<p class="ctt1" id="pz12-2"><span href="#/chapter09" title="Link target outside of Sample">
					In Search of a Quest</span></p>
<p class="ctt" id="pz12-3"><b><span href="#/chapter10#pz73-1" id="ch10" title="Link target outside of Sample">Chapter 10</span></b></p>
<p class="ctt1" id="pz12-4"><span href="#/chapter10" title="Link target outside of Sample">
					My Sanctuary</span></p>
<p class="ctt" id="pz12-7"><b><span href="#/chapter11#pz76-2" id="ch11" title="Link target outside of Sample">Chapter 11</span></b></p>
<p class="ctt1" id="pz12-8"><span href="#/chapter11" title="Link target outside of Sample">
					After Reading Jean Paul Sartre’s: <i>No Exit</i> and <i>The Flies</i></span></p>
<p class="ctt" id="pz12-9"><b><span href="#/chapter12#pz81-1" id="ch12" title="Link target outside of Sample">Chapter 12</span></b></p>
<p class="ctt1" id="pz12-10"><span href="#/chapter12" title="Link target outside of Sample">
					Read All About It</span></p>
<p class="ctt" id="pz12-13"><b><span href="#/chapter13#pz88-2" id="ch13" title="Link target outside of Sample">Chapter 13</span></b></p>
<p class="ctt1" id="pz12-14"><span href="#/chapter13" title="Link target outside of Sample">
					Winter: A Metaphorical Season</span></p>
<p class="ctt" id="pz12-16"><b><span href="#/chapter14#pz91-2" id="ch14" title="Link target outside of Sample">Chapter 14</span></b></p>
<p class="ctt1" id="pz12-17"><span href="#/chapter14" title="Link target outside of Sample">
					Observe Closely</span></p>
<p class="ctt" id="pz12-18"><b><span href="#/chapter15#pz94-2" id="ch15" title="Link target outside of Sample">Chapter 15</span></b></p>
<p class="ctt1" id="pz12-19"><span href="#/chapter15" title="Link target outside of Sample">
					My World, My Words</span></p>
<p class="ctt" id="pz12-22"><b><span href="#/chapter16#pz104-2" id="ch16" title="Link target outside of Sample">Chapter 16</span></b></p>
<p class="ctt1" id="pz12-23"><span href="#/chapter16" title="Link target outside of Sample">
					Beethoven or Baseball?</span></p>
<p class="ctt" id="pz12-25"><b><span href="#/chapter17#pz108-1" id="ch17" title="Link target outside of Sample">Chapter 17</span></b></p>
<p class="ctt1" id="pz12-26"><span href="#/chapter17" title="Link target outside of Sample">
					Happy Birthday, <i>Fine Lines</i></span></p>
<p class="ctt" id="pz13-1"><b><span href="#/chapter18#pz110-1" id="ch18" title="Link target outside of Sample">Chapter 18</span></b></p>
<p class="ctt1" id="pz13-3"><span href="#/chapter18" title="Link target outside of Sample">
					Little Birds with Broken Wings:The Beginning of <i>Fine Lines</i></span></p>
<p class="ctt" id="pz13-4"><b><span href="#/chapter19#pz117-2" id="ch19" title="Link target outside of Sample">Chapter 19</span></b></p>
<p class="ctt1" id="pz13-5"><span href="#/chapter19" title="Link target outside of Sample">
					Oh, the Words We Use</span></p>
<p class="ctt" id="pz13-7"><b><span href="#/chapter20#pz121-1" id="ch20" title="Link target outside of Sample">Chapter 20</span></b></p>
<p class="ctt1" id="pz13-8"><span href="#/chapter20" title="Link target outside of Sample">
					John Gay vs. Bertoldt Brecht: The Three Penny Opera</span></p>
<p class="ctt" id="pz13-10"><b><span href="#/chapter21#pz125-1" id="ch21" title="Link target outside of Sample">Chapter 21</span></b></p>
<p class="ctt1" id="pz13-11"><span href="#/chapter21" title="Link target outside of Sample">
					Vonnegut and Morris: Two Reviews</span></p>
<p class="ctt" id="pz13-13"><b><span href="#/chapter22#pz128-2" id="ch22" title="Link target outside of Sample">Chapter 22</span></b></p>
<p class="ctt1" id="pz13-14"><span href="#/chapter22" title="Link target outside of Sample">
					Dear Me</span></p>
<p class="ctt" id="pz13-16"><b><span href="#/chapter23#pz135-2" id="ch23" title="Link target outside of Sample">Chapter 23</span></b></p>
<p class="ctt1" id="pz13-17"><span href="#/chapter23" title="Link target outside of Sample">
					“Let Them Farm in a Flower Pot”</span></p>
<p class="ctt" id="pz13-19"><b><span href="#/chapter24#pz141-2" id="ch24" title="Link target outside of Sample">Chapter 24</span></b></p>
<p class="ctt1" id="pz13-20"><span href="#/chapter24" title="Link target outside of Sample">
					Believe in Small Things</span></p>
<p class="ctt" id="pz13-22"><b><span href="#/chapter25#pz147-2" id="ch25" title="Link target outside of Sample">Chapter 25</span></b></p>
<p class="ctt1" id="pz13-23"><span href="#/chapter25" title="Link target outside of Sample">
					An Affair of Honor</span></p>
<p class="ctt" id="pz13-25"><b><span href="#/chapter26#pz153-2" id="ch26" title="Link target outside of Sample">Chapter 26</span></b></p>
<p class="ctt1" id="pz13-26"><span href="#/chapter26" title="Link target outside of Sample">
					All Good Things</span></p>
<p class="ctt" id="pz14-1"><b><span href="#/chapter27#pz157-2" id="ch27" title="Link target outside of Sample">Chapter 27</span></b></p>
<p class="ctt1" id="pz14-2"><span href="#/chapter27" title="Link target outside of Sample">
<i>Aztec</i>: A Review and Reflection</span></p>
<p class="ctt" id="pz14-4"><b><span href="#/chapter28#pz163-1" id="ch28" title="Link target outside of Sample">Chapter 28</span></b></p>
<p class="ctt1" id="pz14-5"><span href="#/chapter28" title="Link target outside of Sample">
					Dream Well</span></p>
<p class="ctt" id="pz14-7"><b><span href="#/chapter29#pz167-2" id="ch29" title="Link target outside of Sample">Chapter 29</span></b></p>
<p class="ctt1" id="pz14-8"><span href="#/chapter29" title="Link target outside of Sample">
					Mother’s Nature</span></p>
<p class="ctt" id="pz14-10"><b><span href="#/chapter30#pz171-1" id="ch30" title="Link target outside of Sample">Chapter 30</span></b></p>
<p class="ctt1" id="pz14-12"><span href="#/chapter30" title="Link target outside of Sample">
<i>Memoirs of Pancho Villa</i> by Martín Luis Guzmán: A Review</span></p>
<p class="ctt" id="pz14-13"><b><span href="#/chapter31#pz178-2" id="ch31" title="Link target outside of Sample">Chapter 31</span></b></p>
<p class="ctt1" id="pz14-14"><span href="#/chapter31" title="Link target outside of Sample">
					One Firefly</span></p>
<p class="ctt" id="pz14-16"><b><span href="#/chapter32#pz183-2" id="ch32" title="Link target outside of Sample">Chapter 32</span></b></p>
<p class="ctt1" id="pz14-17"><span href="#/chapter32" title="Link target outside of Sample">
					Les Whipp: A Lighthouse Teacher</span></p>
<p class="ctt" id="pz14-19"><b><span href="#/chapter33#pz187-2" id="ch33" title="Link target outside of Sample">Chapter 33</span></b></p>
<p class="ctt1" id="pz14-20"><span href="#/chapter33" title="Link target outside of Sample">
					Hallelujah</span></p>
<p class="ctt" id="pz14-22"><b><span href="#/chapter34#pz191-2" id="ch34" title="Link target outside of Sample">Chapter 34</span></b></p>
<p class="ctt1" id="pz14-23"><span href="#/chapter34" title="Link target outside of Sample">
					Proverbial Wisdom</span></p>
<p class="ctt" id="pz14-25"><b><span href="#/chapter35#pz196-2" id="ch35" title="Link target outside of Sample">Chapter 35</span></b></p>
<p class="ctt1" id="pz14-26"><span href="#/chapter35" title="Link target outside of Sample">
					The Keys to Understanding</span></p>
<p class="ctt" id="pz15-1"><b><span href="#/chapter36#pz201-2" id="ch36" title="Link target outside of Sample">Chapter 36</span></b></p>
<p class="ctt1" id="pz15-2"><span href="#/chapter36" title="Link target outside of Sample">
					Tomorrow</span></p>
<p class="ctt" id="pz15-4"><b><span href="#/chapter37#pz210-2" id="ch37" title="Link target outside of Sample">Chapter 37</span></b></p>
<p class="ctt1" id="pz15-5"><span href="#/chapter37" title="Link target outside of Sample">
					Such a Wonderful Gift</span></p>
<p class="ctt" id="pz15-7"><b><span href="#/chapter38#pz216-1" id="ch38" title="Link target outside of Sample">Chapter 38</span></b></p>
<p class="ctt1" id="pz15-8"><span href="#/chapter38" title="Link target outside of Sample">
					The Goal Is the Soul: An Interview of David Martin by Sjon Ashby</span></p>
<p class="ctt" id="pz15-10"><b><span href="#/chapter39#pz239-2" id="ch39" title="Link target outside of Sample">Chapter 39</span></b></p>
<p class="ctt1" id="pz15-11"><span href="#/chapter39" title="Link target outside of Sample">
					Ripples of Hope</span></p>
<p class="ctt" id="pz15-14"><b><span href="#/chapter40#pz243-1" id="ch40" title="Link target outside of Sample">Chapter 40</span></b></p>
<p class="ctt1" id="pz15-16"><span href="#/chapter40" title="Link target outside of Sample">
					After 20 Years: <i>Fine Lines</i> Celebrates the “Best of the Best”</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0a4fd169